import { formatDate } from '@fiverr-private/futile';

const MS_IN_SEC = 1000;

export const formatTimestamp = (timestamp: string | number) => {
    const date = new Date(Number(timestamp) * MS_IN_SEC);
    return formatDate(date);
};
